import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Box,
} from '@mui/material';
import PropTypes from 'prop-types';

export default function PermanentDeleteDialog({
  openDelete,
  setOpenDelete,
  nameToBeDeleted,
  nameType,
  message,
  handleOk,
}) {
  const [name, setName] = useState();
  const [validName, setValidName] = useState(false);

  const handleFormValueChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    switch (name) {
      case 'name':
        setName(value);
        if (nameToBeDeleted === value) {
          setValidName(true);
        } else {
          setValidName(false);
        }
        break;
      default:
        break;
    }
  };

  return (
    <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
      <Box sx={{ backgroundColor: (theme) => theme.palette.mode === 'light' ? '#F9F9FB' : '#272424' }}>
        <DialogTitle>
          እርግጠኛ ንዎት {nameToBeDeleted} {nameType}ን መሰረዝ ይፈልጋሉ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            በዚህ {nameType} ስር ያሉ ሁሉም {message} ይጠፋሉ!
          </DialogContentText>
          <DialogContentText>ይህ እርምጃ ሊቀለበስ አይችልም።</DialogContentText>
          <DialogContentText>
            በማጥፋቶ እርግጠኛ ከሆኑ ፣ የሚአጠፉትን {nameType} ስም( <b>{nameToBeDeleted}</b>)ን ከታች ጻፉ!
          </DialogContentText>
          <DialogContentText>
            <Box sx={{ mt: 1 }}>
              <TextField
                error={!validName}
                success={validName}
                name="name"
                label={`የሚአጠፉትን ${nameType} ስም ይጻፉ!`}
                value={name}
                fullWidth
                onChange={handleFormValueChange}
              />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)}>ተመለስ</Button>
          <Button disabled={!validName} color="error" variant="contained" onClick={handleOk} autoFocus>
            ሰርዝ
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

// PropTypes validation
PermanentDeleteDialog.propTypes = {
  openDelete: PropTypes.bool.isRequired,
  setOpenDelete: PropTypes.func.isRequired,
  nameToBeDeleted: PropTypes.string.isRequired,
  nameType: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  handleOk: PropTypes.func.isRequired,
};
